/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_2_TInputs */

const en_cp_jr_2_t = /** @type {(inputs: Cp_Jr_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint`)
};

const id_cp_jr_2_t = /** @type {(inputs: Cp_Jr_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint`)
};

/**
* | output |
* | --- |
* | "Sprint" |
*
* @param {Cp_Jr_2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_2_t = /** @type {((inputs?: Cp_Jr_2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_2_t(inputs)
	return en_cp_jr_2_t(inputs)
});